__turbopack_context__.v({
  "pill": "styles-module__3E1BAW__pill",
  "pillList": "styles-module__3E1BAW__pillList",
  "scrollableContainer": "styles-module__3E1BAW__scrollableContainer",
});
